import { useNavPerf } from "@/hooks/useNavPerf";

export function NavPerfTracker() {
  useNavPerf();
  return null;
}
